import { Reveal } from '../components/Reveal'
import { Kicker } from '../components/Kicker'
import { FluidHeading } from '../components/FluidHeading'

const ORBIT_ITEMS = ['Estratégia', 'Tráfego', 'Criativo', 'Página', 'Conversão', 'Otimização']
const ORBIT_RADIUS = 42
const INNER_RADIUS = 18

const ORBIT_POINTS = ORBIT_ITEMS.map((item, i) => {
  const angle = (i * 60 - 90) * (Math.PI / 180)
  return {
    item,
    x: 50 + Math.cos(angle) * ORBIT_RADIUS,
    y: 50 + Math.sin(angle) * ORBIT_RADIUS,
    ix: 50 + Math.cos(angle) * INNER_RADIUS,
    iy: 50 + Math.sin(angle) * INNER_RADIUS,
  }
})

function ResultCore({ size = 'h-32 w-32 sm:h-40 sm:w-40' }: { size?: string }) {
  return (
    <div className={`glow-border relative flex ${size} flex-col items-center justify-center rounded-full bg-gradient-to-br from-orb-500 to-orb-800 text-center`}>
      <span
        aria-hidden="true"
        className="absolute inset-[-20%] animate-pulse-slow rounded-full bg-orb-500/25 blur-2xl"
      />
      <span className="relative text-[10px] uppercase tracking-[0.25em] text-orb-100/70">
        O centro de tudo
      </span>
      <span className="relative mt-1 font-display text-lg font-bold text-white sm:text-xl">
        RESULTADO
      </span>
    </div>
  )
}

export function Method() {
  return (
    <section id="metodo" className="relative mx-auto max-w-6xl px-5 py-24 sm:px-8 sm:py-32">
      <Reveal>
        <div className="mx-auto flex max-w-2xl flex-col items-center text-center">
          <Kicker>Como pensamos</Kicker>
          <FluidHeading as="h2" className="text-3xl font-semibold text-white sm:text-5xl">
            Tudo orbita o mesmo objetivo: <span className="text-gradient">resultado</span>
          </FluidHeading>
          <p className="mt-4 text-white/55">
            Estratégia, tráfego, criativo, página e dados não são etapas isoladas — são partes
            conectadas do mesmo sistema.
          </p>
        </div>
      </Reveal>

      {/* Desktop / tablet: diagrama orbital */}
      <div className="relative mx-auto mt-16 hidden aspect-square w-full max-w-[520px] sm:block">
        <svg viewBox="0 0 100 100" className="absolute inset-0 h-full w-full" aria-hidden="true">
          <circle
            cx="50"
            cy="50"
            r={ORBIT_RADIUS}
            fill="none"
            stroke="rgba(168,116,255,0.18)"
            strokeWidth="0.4"
          />
          {ORBIT_POINTS.map((p) => (
            <line
              key={p.item}
              x1={p.ix}
              y1={p.iy}
              x2={p.x}
              y2={p.y}
              stroke="rgba(168,116,255,0.28)"
              strokeWidth="0.4"
            />
          ))}
        </svg>

        <div className="absolute inset-[8%] animate-spin-slow rounded-full" aria-hidden="true">
          <span className="absolute left-1/2 top-0 h-2 w-2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-orb-300 shadow-[0_0_10px_3px_rgba(200,160,255,0.9)]" />
        </div>

        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
          <Reveal y={0}>
            <ResultCore />
          </Reveal>
        </div>

        {ORBIT_POINTS.map((p, i) => (
          <div
            key={p.item}
            className="absolute -translate-x-1/2 -translate-y-1/2"
            style={{ left: `${p.x}%`, top: `${p.y}%` }}
          >
            <Reveal delay={i * 0.08} y={14}>
              <div className="whitespace-nowrap rounded-full border border-orb-400/25 bg-orb-500/10 px-5 py-2.5 text-center text-xs font-medium text-white backdrop-blur-sm sm:px-6 sm:py-3 sm:text-sm">
                {p.item}
              </div>
            </Reveal>
          </div>
        ))}
      </div>

      {/* Mobile: composição vertical com hierarquia explícita */}
      <div className="mt-14 flex flex-col items-center sm:hidden">
        <div className="grid w-full grid-cols-2 gap-3">
          {ORBIT_ITEMS.map((item, i) => (
            <Reveal key={item} delay={i * 0.06}>
              <div className="rounded-full border border-orb-400/25 bg-orb-500/10 px-4 py-3.5 text-center text-sm font-medium text-white">
                {item}
              </div>
            </Reveal>
          ))}
        </div>

        <div
          aria-hidden="true"
          className="my-4 h-9 w-px bg-gradient-to-b from-orb-400/50 to-orb-400/10"
        />

        <Reveal>
          <ResultCore size="h-28 w-28" />
        </Reveal>
      </div>
    </section>
  )
}
